import { getTefLevelByScore } from "@/data/tefScoreScale";

/**
 * Standardized NCLC and CEFR levels based on the TEF Writing (EE) 450-point scale.
 * Note: getTefLevelByScore from tefScoreScale.ts is the primary source, 
 * but we provide this fallback for writing specifically.
 */
export function getWritingNclcFromScore(score: number) {
  if (score >= 393) return { nclc: "10+", cefr: "C1/C2" };
  if (score >= 371) return { nclc: "9", cefr: "C1" };
  if (score >= 349) return { nclc: "8", cefr: "B2" };
  if (score >= 310) return { nclc: "7", cefr: "B2" };
  if (score >= 271) return { nclc: "6", cefr: "B1" };
  if (score >= 226) return { nclc: "5", cefr: "B1" };
  if (score >= 181) return { nclc: "4", cefr: "A2" };
  return { nclc: "<4", cefr: "A1" };
}

export function normalizeWritingCorrection(raw: any) {
  if (!raw) return null;

  const scoreRaw =
    raw?.totalScore ??
    raw?.score ??
    raw?.estimatedScore ??
    raw?.pontuacao ??
    raw?.pontuacaoEstimada ??
    raw?.result?.score ??
    raw?.metadata?.totalScore ??
    raw?.metadata?.score ??
    0;

  const score = Number(scoreRaw) || 0;

  const maxScoreRaw =
    raw?.maxScore ??
    raw?.maximumScore ??
    raw?.result?.maxScore ??
    raw?.metadata?.maxScore ??
    450;

  const maxScore = Number(maxScoreRaw) || 450;

  const levels = getWritingNclcFromScore(score);

  const nclc =
    raw?.nclc ??
    raw?.nclcLevel ??
    raw?.nclcEstimate ??
    raw?.niveauNCLC ??
    raw?.result?.nclc ??
    raw?.metadata?.nclc ??
    levels.nclc;

  const cefr =
    raw?.cefr ??
    raw?.cefrLevel ??
    raw?.cecrl ??
    raw?.cecrlEstimate ??
    raw?.result?.cefr ??
    raw?.metadata?.cefr ??
    levels.cefr;

  return {
    ...raw,
    score,
    totalScore: score,
    maxScore,
    nclc: String(nclc),
    cefr: String(cefr),
    nclcLevel: String(nclc),
    cefrLevel: String(cefr),
  };
}

export function resolveWritingScore(record: any): number | null {
  const value =
    record?.score ??
    record?.total_score ??
    record?.metadata?.totalScore ??
    record?.metadata?.score ??
    record?.metadata?.writingCorrection?.totalScore ??
    record?.metadata?.writingCorrection?.score ??
    null;

  const numberValue = Number(value);

  return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : null;
}

export function resolveWritingMaxScore(record: any): number {
  return Number(
    record?.max_score ??
    record?.maxScore ??
    record?.metadata?.maxScore ??
    record?.metadata?.writingCorrection?.maxScore ??
    450
  ) || 450;
}
